import { WIZARD_STEPS, type WizardStep } from './relatorio-civel-page.models';

/** Etapas exclusivas do relatório criminal (após as 17 do cível). */
export const WIZARD_STEPS_CRIMINAL_EXTRA: WizardStep[] = [
  { id: 18, title: 'Outras Manifestações', shortTitle: 'Outras Manifest.' },
  { id: 19, title: 'Ciência', shortTitle: 'Ciência' },
];

export type RelatorioTipoAtividade = 'civil' | 'criminal';

export const CRIMINAL_STEP_OUTRAS_MANIFESTACOES = 18;
export const CRIMINAL_STEP_CIENCIA = 19;

export function getWizardStepsForTipo(tipo: RelatorioTipoAtividade): WizardStep[] {
  return tipo === 'criminal' ? [...WIZARD_STEPS, ...WIZARD_STEPS_CRIMINAL_EXTRA] : WIZARD_STEPS;
}

export function getTipoRelatorioLabel(tipo: RelatorioTipoAtividade): string {
  return tipo === 'criminal' ? 'Criminal' : 'Cível';
}

export function isEtapaCriminalExclusiva(step: number): boolean {
  return step === CRIMINAL_STEP_OUTRAS_MANIFESTACOES || step === CRIMINAL_STEP_CIENCIA;
}
